// extracted by mini-css-extract-plugin
export default {"content":"index_content_xq9ai","other":"index_other_AW9eH","rules":"index_rules_-PcaI"};